import routes from './src/billing-app-routes';
import onboardingStore from './src/billing-app-store';
import billingStore from './src/store/modules/billing';
import dgBillingStore from './src/store/modules/dgBilling';
import rateMasterStore from './src/store/modules/rateMaster';
import configMixin from './src/mixins/configMixin';
import appConfig from './src/config/appConfig';
import { refreshApiServices, BusinessHoursService } from './src/services';

function loadLocaleMessages(i18nInstance) {
  const locales = require.context('./src/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      i18nInstance.mergeLocaleMessage(locale, locales(key));
    }
  });
}

const loadBusinessHoursTimezone = async () => {
  if (!BusinessHoursService?.applyTimezoneConfig) {
    return;
  }

  try {
    await BusinessHoursService.applyTimezoneConfig();
  } catch (error) {
    console.warn('[BillingApp] Failed loading business hours timezone:', error);
  }
};

export default {
  install(Vue, options) {
    appConfig.setParentStore(options.store);
    refreshApiServices();
    loadBusinessHoursTimezone();
    Vue.mixin(configMixin);
    const routerData = options.router.options.routes.find((r) => r.path === '/');
    routerData.children = routes;
    options.router.addRoutes([routerData]);
    options.store.registerModule('billingApp', onboardingStore);
    options.store.registerModule('billing', billingStore);
    options.store.registerModule('dgBilling', dgBillingStore);
    options.store.registerModule('rateMaster', rateMasterStore);
    if (!options.store.hasModule('billingNotifications')) {
      options.store.registerModule('billingNotifications', {
        namespaced: false,
        actions: {
          showSnackbar({ commit }, { message, color = 'info' }) {
            commit('helper/setAlert', {
              show: true,
              type: color === 'error' ? 'error' : 'success',
              message,
            }, { root: true });
          },
        },
      });
    }
    loadLocaleMessages(options.i18n);
  },
};
